import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import { fetchGroupsList } from 'common/groups/actions/groupsActions'
import { fetchBotSettings } from 'common/settings/actions/botSettingsActions'
import { isBotAdminsReady } from 'common/settings/selectors/botSettingsSelectors'

export const useFetchAssigneeData = (shouldFetch: boolean = true) => {
  const dispatch = useAppDispatch()

  const isBotSettingsReady = useAppSelector(isBotAdminsReady)
  const [isGroupsReady, setGroupsReady] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      if (!shouldFetch) {
        return
      }

      dispatch(fetchBotSettings())
      await dispatch(fetchGroupsList())
      setGroupsReady(true)
    }

    fetchData()
  }, [dispatch, shouldFetch])

  return {
    isDataLoaded: !shouldFetch || (isBotSettingsReady && isGroupsReady),
  }
}
